import { useInfiniteQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { SessionRepositoryImpl } from "../../data/repository/session_repository_impl";
import { SessionInterface } from "../interface/session_interface";
import { useMemo } from "react";
import { useOutletContext } from "react-router-dom";
import { UserInterface } from "../../../../core/components/user/domain/interfaces/user_interface";

interface PaginatedSessionsResponse {
    sessions: SessionInterface[];
    fetchedAll: boolean;
}

export const useGetIncomingSession = (limit: number = 10) => {
    const repository = new SessionRepositoryImpl();
    const { company } = useOutletContext<UserInterface>();

    const query = useInfiniteQuery<PaginatedSessionsResponse, AxiosError>({
        queryKey: ['incomingSessions', limit, company?.id],
        queryFn: async ({ pageParam = 0 }) => {
            const result = await repository.getIncomingSession(pageParam as number, limit);
            
            return {
                sessions: result.sessions,
                fetchedAll: result.fetchedAll
            };
        },
        retry: 4,
        staleTime: 15 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        getNextPageParam: (lastPage, allPages) => {
            const currentPageNumber = allPages.length;
            
            if (!lastPage.fetchedAll) {
                return currentPageNumber * limit;
            }
            return undefined;
        },
        initialPageParam: 0,
    });

    const allSessions = useMemo(() => 
        query.data?.pages.flatMap(page => page.sessions) || []
    , [query.data]);

    return { ...query, allSessions };
};